<template>
  <div class="Prize" v-if="prize">
    <div class="team">
      <div class="v-subheader mt-0">우승팀 1위</div>
      <div class="list">
        <div>
          <a v-if="prize.team[0].href" :href="prize.team[0].href" target="_blank">
            <div class="circle">
              <div class="image">
                <img :src="prize.team[0].img" alt="">
              </div>
              <div class="name">
                {{ prize.team[0].name }}
              </div>
            </div>  
          </a>
          <div class="circle" v-else>
            <div class="image">
              <img :src="prize.team[0].img" alt="">
            </div>
            <div class="name">
              {{ prize.team[0].name }}
            </div>
          </div>
        </div>
        <div style="flex: 0; font-weight: bolder; color: #888;">or</div>
        <div>
          <a v-if="prize.team[1].href" :href="prize.team[1].href" target="_blank">
            <div class="circle">
              <div class="image">
                <img :src="prize.team[1].img" alt="">
              </div>
              <div class="name">
                {{ prize.team[1].name }}
              </div>
            </div>  
          </a>
          <div class="circle" v-else>
            <div class="image">
              <img :src="prize.team[1].img" alt="">
            </div>
            <div class="name">
              {{ prize.team[1].name }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="prize.team.winner">
        {{ prize.team.winner }}
      </div>
    </div>
    <div class="personal">
      <div class="v-subheader mt-0">개인별</div>
      <div class=list>
        <div v-for="(p, i) in prize.personal" :key=i>
          <a v-if="p.href" :href="p.href" target="_blank">
            <div class="circle">
              <div class="image">
                <img :src="p.img" alt="">
              </div>
              <div class="rank" :class="['rank' + (i + 1)]">{{ i + 1 }}등</div>
              <div class="name">
                {{ p.name }}
              </div>
            </div>
          </a>
          <div class="circle" v-else>
            <div class="image">
              <img :src="p.img" alt="">
            </div>
            <div class="rank" :class="['rank' + (i + 1)]">{{ i + 1 }}등</div>
            <div class="name">
              {{ p.name }}
            </div>
          </div>
          <div v-if="p.winner">
            {{ p.winner }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Prize',
  props: ['prize', 'players'],
  data: () => ({
  })
}
</script>

<style scoped>
.Prize {
  display: flex;
  flex-direction: row;
  max-width: 1080px;
  margin: 40px auto 0;
  padding: 0 1em;
  gap: 1em;
}
.Prize>div {
  border: solid 1px #b0b0ba;
  background: #f3f4f7;
  padding: 1em;
  flex: 1;
}
.list {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 2rem;
}
.team .list, .personal .list {
  justify-content: space-around;
}
.list>div {
  margin: 2em 0;
  width: 150px;
}
.list .circle {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
}
.list .circle::before {
  content: "";
  transition-property: all;
  transition-duration: .2s;
  border-radius: 50%;
  z-index: 0;
  position: absolute;
  inset: 0px;
  margin: -0.2rem;
  border-width: 0.2rem;
  border-style: solid;
  border-color: #b0b0ba;
}
.list .circle:hover::before {
  border-width: 0.43rem;
  transform: scale(1.04167);
}
.list .image {
  display: flex;
  align-items: center;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  overflow: hidden;
  background: white;

}
.list .image>img {
  width: 100%;
}
.list .rank {
  position: absolute;
  margin: 0 auto;
  padding: .2rem;
  width: 3rem;
  top: -.6rem;
  left: 0;
  right: 0;
  color: white;
  font-size: 1rem;
  font-weight: 800;
  text-shadow: 0 0 2px black;
  background-image: url(/static/img/prize/texture.jpg);
  background-size: 69px;
  background-position-x: -10px;
  background-repeat: no-repeat;
  border-radius: .5rem;
}
.list .rank.rank2 {
  background-position-y: -38px;
}
.list .rank.rank3 {
  background-position-y: -75px;
}
.list .name {
  position: absolute;
  padding: .2rem;
  bottom: -.4rem;
  left: 0;
  right: 0;
  color: white;
  font-size: .8rem;
  background: #b0b0ba;
  border-radius: .5rem;
}
@media screen and (max-width: 1440px) {
.Prize {
  flex-direction: column;
}
}
@media screen and (max-width: 860px) {
.personal .list {
  flex-direction: column;
}
}
@media screen and (max-width: 540px) {
.team .list {
  flex-direction: column;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Prize.vue